'use strict';

wbApp.factory('notificationSvc', ['$timeout',
    function ($timeout) {

        var duration = 5000;
        var queue = [];

        function notifyInfo(title, message) {
            notify({ type: 'success', title: title, content: message });
        }

        function notifyWarning(title, message) {
            notify({ type: 'warning', title: title, content: message });
        }

        function notifyError(title, message) {
            notify({ type: 'danger', title: title, content: message });
        }

        function notify(notification) {
            queue.push(notification);
            $timeout(function() {
                notification.show = false;
            }, duration);
        }

        function fatalNotify(message) {
            alert(message);
        }

        function getQueue() {
            return queue;
        }

        function translateError(data) {
            var message = "";
            if (!!data && !!data.errors) {
                for (var i = 0; i < data.errors.length; i++) {
                    message += "<div>" + data.errors[i].message + "</div>";
                }
            }
            if (!!data && !!data.validationErrors) {
                for (var i = 0; i < data.validationErrors.length; i++) {
                    message += "<div>"+ data.validationErrors[i].description + "</div>";
                }
            }
            if (!!data && !!data.ValidationErrors) {
                for (var i = 0; i < data.ValidationErrors.length; i++) {
                    message += "<div>" + data.ValidationErrors[i].Description + "</div>";
                }
            }
            if (!!data && !!data.title) {
                message += "<div>" + data.title + "</div>";
            }
            return message;
        }

        var advertiseCallback = null;
        function registerAdvertiseCallback(callback) {
            advertiseCallback = callback;
        }

        function advertiseLogin(urlParams) {
            if (advertiseCallback) {
                $timeout(function () {
                    advertiseCallback(urlParams);
                });
            }
        }

        return {
            notifyInfo: notifyInfo,
            notifyWarning: notifyWarning,
            notifyError: notifyError,
            fatalNotify: fatalNotify,
            getQueue: getQueue,
            translateError: translateError,
            advertiseLogin: advertiseLogin,
            registerAdvertiseCallback: registerAdvertiseCallback
        }
    }]);